export default {
  title: 'Menu edit history',
  subtitle: 'See who changed prices, availability and visibility for {{company}} — and when.',
  filters: {
    type: {
      label: 'Type',
    },
    item: {
      placeholder: 'All items',
    },
    event: {
      label: 'Event',
    },
  },
  columns: {
    when: 'When',
    who: 'Changed by',
    type: 'Type',
    item: 'Item',
    event: 'Event',
    changes: 'Changes',
  },
  types: {
    product: 'Product',
    modifier: 'Modifier',
    category: 'Category',
    modifier_group: 'Modifier group',
    menu: 'Menu',
  },
  events: {
    created: 'Created',
    updated: 'Updated',
    deleted: 'Deleted',
  },
  fields: {
    name: 'Name',
    description: 'Description',
    price: 'Price',
    is_available: 'Availability',
    is_visible: 'Visibility',
    is_available_for_pickup: 'Pickup availability',
    is_available_for_delivery: 'Delivery availability',
    tax_category_id: 'Tax category',
    schedule: 'Times shown',
    is_required: 'Required',
    max_count: 'Most choices',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Pickup price',
    delivery: 'Delivery price',
    dine_in: 'Dine-in price',
    room_service: 'Room service price',
  },
  booleans: {
    on: 'Available',
    off: 'Unavailable',
    yes: 'Yes',
    no: 'No',
  },
  schedule: {
    always: 'Always',
    every_day: 'Every day',
  },
  pagination: {
    previous: 'Previous',
    next: 'Next',
  },
  causers: {
    undo: 'Undo',
    orders_terminal: 'Orders terminal',
    approved_by: {
      amigo: 'Amigo, approved by {{name}}',
      assistant: 'Assistant, approved by {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Open in the Amigo log',
  system: 'System',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Failed to load the menu edit history',
  },
};
